/**
table.table.responsive
				thead
				tbody
					each card in storedcards
						tr
							td=card.cardType
							td=card.number
							td #{card.expMonth}/#{card.expYear}
							td=card.name
							td
								if account.automaticPaymentCard == card.id
									a(href="/#{area}/family/removeautopay/#{account.id}").btn.btn-success.inline Remove Auto Payments
								else
									a(href="/#{area}/family/setautopay/#{account.id}/#{card.id}").btn.btn-success.inline Turn Auto Pay On
								a(href="/#{area}/family/removecard/#{account.id}/#{card.id}").btn.btn-danger.inline Remove
*/

import 'idempotent-babel-polyfill';
import { h, render, Component } from 'preact';
function renderTo(comp, mount) {
	render(comp, mount, mount.lastChild as any);
}
//ds.teacher.payrecords(
import { CDS, postJSON, toUrl, getJSON, postForm } from "../../apps/shared/wui/fetch";
import { PayStub } from '../../apps/shared/shared';
class RestDataClient {
	get Families() {
		return new FamilyRC();
	}
}
class FamilyRC {
	paymentMethods(accountId) {
		return getJSON<any[]>(`/api/families/savedPaymentMethods/${accountId}`)
	}
}
let rc = new RestDataClient();
import { LoadingComponent } from '../../apps/shared/wui/components/page';
// @ts-ignore
export class SavedPaymentMethods extends LoadingComponent<{}, any> {
	async loadData() {
		// @ts-ignore
		this.setState({ savedPaymentMethods: await rc.Families.paymentMethods(window.locals.account.id) })
	}
	rrender() {
		return <table>
			<thead></thead>
			<tbody>
				{this.state.savedPaymentMethods.map(card => <tr>
					<td>{card.cardType}</td>
					<td>{card.number}</td>
					<td>{card.expMonth}/{card.expYear}</td>
					<td>{card.name}</td>
					<td>
						{/* @ts-ignore */}
						{window.locals.account.automaticPaymentCard == card.id &&
							// @ts-ignore
							<a href={`/family/removeautopay/${window.locals.account.id}`} class="btn btn-success inline">Remove Auto Payments</a>
						}
						{/* @ts-ignore */}
						{window.locals.account.automaticPaymentCard != card.id
							// @ts-ignore
							&& <a href={`/family/setautopay/${locals.account.id}/${card.id}`} class="btn btn-success inline"> Turn Auto Pay On</a>}
						{/* @ts-ignore */}
						<a href={`/${locals.area}/family/removecard/${window.locals.account.id}/${card.id}`}>Remove</a>
					</td>




				</tr>)}
			</tbody>
		</table>
	}
}
renderTo(<SavedPaymentMethods />, document.getElementById('savedPaymentMethods'))